<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="{ or: ['Product_Product_Edit', 'Product_Product_Add'] }" :buttons="[buttons_prev, buttons_next, metaDataBtn, settings_button, button_snapshot]">
		<template #badges>
			<nk-badge system="warehouse">
				<nk-badge-item type="system" :modelValue="'warehouse'"></nk-badge-item>
				<nk-badge-item type="part" :modelValue="'warehouse.product'"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'new' : 'edit'"></nk-badge-item>
				<nk-badge-item type="part" :modelValue="'warehouse.product'" v-if="localData.name" :title="localData.name"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="container-fluid h-100">
			<div class="row flex-row-reverse h-100 form-container">
				<div class="col-12">
					<div class="nk-card">
						<div class="d-flex gap-10">
							<div class="row flex-grow-1">
								<div class="col-sm-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.code') + ':'" :labelSizes="{ sm: 'auto' }" :dataSizes="{ sm: 'grow', md: 'grow' }">
										<nk-input :options="componentOptions.code" v-model="localData.code" :tabindex="102" @blur="onBlur" ref="inputCode" @searchClick="allProducts" startup :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
									</nk-col-form-group>
								</div>
								<div class="col-sm-8 col-12">
									<nk-col-form-group :label="$t('sale.product.f.name') + ':'" :labelSizes="{ sm: 'auto' }" :dataSizes="{ sm: 'grow', md: 'grow' }">
										<nk-input :options="componentOptions.string" v-model="localData.name" :tabindex="103" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
									</nk-col-form-group>
								</div>
							</div>
							<div class="visual-card"></div>
						</div>
					</div>
					<div class="d-flex gap-10 my-2 flex-column flex-sm-row">
						<div class="nk-card information-card order-2 order-sm-1">
							<div class="row">
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.productGroup') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-dropdown-product-group v-model="localData.productGroup" ref="productGroup" :options="componentOptions.group" :tabindex="104" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-dropdown-product-group>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.kind') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-dropdown v-model="productKind" :data="kind" :options="componentOptions.kind" :tabindex="105" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-dropdown>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.nameAlternate') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-input :options="componentOptions.string" v-model="localData.nameAlternate" :tabindex="106" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.technicalNumber') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-input :options="componentOptions.string" v-model="localData.technicalNumber" :tabindex="107" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.defaultWarehouse') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-dropdown-warehouse v-model="localData.defaultWarehouse" :options="componentOptions.warehouse" :tabindex="108" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-dropdown-warehouse>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.productClassification') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-dropdown-product-classification v-model="localData.productClassification" :options="componentOptions.classification" :tabindex="109" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-dropdown-product-classification>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.marketingPercentage') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-input :options="percentOptions" v-model="localData.marketingPercentage" :tabindex="113" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<nk-col-form-group :label="$t('sale.product.f.moadianCode') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-input :options="componentOptions.string" v-model="localData.moadianCode" :tabindex="110" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
									</nk-col-form-group>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
									<div class="d-flex gap-5">
										<nk-col-form-group v-if="!localData.isTaxFree" :label="$t('sale.product.f.taxAmount') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
											<nk-input v-model="localData.tax" :tabindex="111" :options="percentOptions" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
										</nk-col-form-group>

										<nk-col-form-group v-if="!localData.isTaxFree" :label="$t('sale.product.f.tollAmount') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
											<nk-input v-model="localData.toll" :tabindex="112" :options="percentOptions" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-input>
										</nk-col-form-group>
									</div>
								</div>
								<div class="col-sm-6 col-lg-4 col-12">
								</div>
							</div>

						</div>
						<div class="nk-card visual-card order-1 order-sm-2">
							<div class="row">
								<div class="col-12">
									<div class="image-container col-6">
										<nk-image-uploader ref="imageUploader" :options="componentOptions.imageUploader" :modelValue="localData.imageUrl" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" />
									</div>
								</div>
								<div class="col-12">
									<div class="d-flex">
										<nk-switch class="d-inline ml-2 switch-position" v-model="localData.isEnabled" :tabindex="114"></nk-switch>
										<span>{{ $t('sale.product.f.isEnabled') }}</span>
									</div>
								</div>
								<div class="col-12 my-2">
									<div class="d-flex">
										<nk-switch class="d-inline ml-2 switch-position" v-model="localData.isSerialized" :tabindex="115"></nk-switch>
										<span>{{ $t('sale.product.f.isSerialized') }}</span>
									</div>
								</div>
								<div class="col-12">
									<div class="d-flex">
										<nk-switch class="d-inline ml-2 switch-position" @update:modelValue="taxChanged" v-model="localData.isTaxFree" :tabindex="116"></nk-switch>
										<span>{{ $t('sale.product.f.isTaxAndTollFree') }}</span>
									</div>
								</div>

							</div>

						</div>
					</div>

					<nk-stabs :activeTab="activeTab" :tabindex="200" :scrollable="true" @activeTabChanged="onActiveTabChanged" class="nk-card h-grow-lock">
						<nk-stab :id="'product-unit'" :name="$t('sale.product.tab.productUnit')">
							<nk-table :data="localData.units" :options="componentOptions.units" v-model="selectedItem" tabindex="201" class="w-100 product-table " ref="unitTable" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">
							</nk-table>
						</nk-stab>
						<nk-stab :id="'product-barcode'" :name="$t('sale.product.tab.productBarcode')">
							<nk-table :data="localData.barcodes" :options="componentOptions.barcodes" v-model="selectedItem" tabindex="202" class="w-100 product-table" ref="barcodeTable" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">
							</nk-table>
						</nk-stab>
						<nk-stab :id="'product-floating'" :name="$t('sale.product.tab.productFloating')" class="position-relative">
							<div class="no-floating" v-if="!floatings || floatings.length === 0">
								<span>{{ $t('sale.product.m.no-floating-defined') }}</span>
								<a class="no-floating-link" @click="showFloatingList">{{ $t('sale.product-floating-list.title') }}</a>
							</div>
							<nk-table :data="floatingsTableData" :options="componentOptions.floatings" v-model="selectedFloatingRow" tabindex="203" class="w-100 product-table" ref="floatingTable" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-table>
						</nk-stab>
						<nk-stab :id="'product-price'" :name="$t('sale.product.tab.productPrice')">
							<nk-table :data="pricesTableData" v-if="priceTableToggler" :options="componentOptions.prices" v-model="selectedItem" tabindex="116" ref="priceTable" class="w-100 product-table" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">
							</nk-table>
						</nk-stab>
						<nk-stab :id="'barcode-prices'" :name="$t('sale.product.tab.barcodePrices')">
							<nk-table :data="barcodePricesTableData" :options="componentOptions.barcodePrices" v-model="selectedBarcodePriceRow" tabindex="204" class="w-100 product-table" ref="barcodePricesTable" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">
							</nk-table>
						</nk-stab>
						<nk-stab :id="'order-point'" :name="$t('sale.product.tab.orderPoint')">
							<div class="order-point-hint">{{ $t('sale.product.order-point-hint') }}</div>
							<nk-table :data="orderPointTableData" v-if="orderPointToggler" :options="componentOptions.orderPoints" v-model="selectedItem" tabindex="117" ref="orderPointTable" class="w-100 product-table" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">
							</nk-table>
						</nk-stab>
						<!-- <nk-stab :id="'product-costFormula'" :name="$t('sale.product.tab.productOperatingCostFormula')">
							<nk-table :data="localData.formulas" :options="componentOptions.productCostFormulaItems" v-model="selectedItem" tabindex="204" class="w-100 product-table " ref="formulaTable" startup :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">
							</nk-table>
						</nk-stab> -->
						<nk-stab :id="'product-stock'" :name="$t('sale.product.tab.productStock')">
							<nk-table :data="stocksTableData" :options="componentOptions.stock" v-model="selectedItem" tabindex="205" class="w-100 product-table " ref="stockTable" startup :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null">

							</nk-table>
						</nk-stab>
						<nk-stab :id="'product-warehouses'" :name="$t('sale.product.tab.product-warehouses')">
							<nk-table v-model="selectedRow" :data="relatableWarehouses" :options="componentOptions.relatableWarehouses" ref="relatableWarehousesTable" tabindex="220">
							</nk-table>
						</nk-stab>
						<nk-stab :id="'additional-fields'" :name="$t('sale.product.tab.additional-fields')">
							<div v-if="$refs.metaDataList && $refs.metaDataList.metaDatas.length === 0 && [FORM_MODES.EDITABLE].includes(settings.mode)" class="row w-100 h-100 justify-content-center align-items-center flex-column gap-10 mt-5">
								<div class="bold-title">{{ $t('sale.product.m.no-additional-field-found') }}</div>
								<nk-button class="mb-4" @click="metaDataModal" :options="componentOptions.addMetaDataButton" />
							</div>
							<nk-metadata ref="metaDataList" :tabindex="121" :options="metaDataListOptions" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" />
						</nk-stab>
					</nk-stabs>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import $sc from '~/plugins/shortcut.collection.js'
	import emptyId from '~/statics/empty-id'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import Endpoints from '@nikan/endpoints'
	import Input from '~/components/general/nikan-input.vue'
	import Dropdown from '~/components/general/dropdown.vue'
	import WarehouseDropdown from '~/components/form/dropdown/dropdown-warehouse.vue'
	import FloatingCenterMultichoice from '~/components/form/multichoice/multichoice-floating-center.vue'
	import Switch from '~/components/general/nikan-switch.vue'
	import BooleanView from '~/components/form/boolean-label'
	import ProductList from './product-list.vue'
	import DropdownProductMeasureUnit from '~/components/form/dropdown/dropdown-product-measure-unit.vue'
	import { mapGetters, mapActions } from 'vuex'
	import MetaDataSchemaModify from '~/components/form/meta-data/meta-data-schema-modify.vue'
	import DatePicker from '../../../components/general/nikan-date.vue'
	import TabOrder from '~/statics/taborder-functions'
	import ProductFloatingList from './product-floating-list.vue'
	import validators, {
		Checker,
		isEmpty,
		VGreaterThan,
		VLessThan,
		VEmptyIf,
		VRequiredIfEmpty,
		VCustom,
	} from '~/statics/validators.js'
	import SaleSettings from '~/views/settings/settings-sale'
	import { defineAsyncComponent } from 'vue'
	import UpdateCode from '@/components/form/salary/personnel/update-code.vue'
	import DropdownInput from '@/components/general/dropdown-input.vue'
	import { WeightUnit, DimensionUnit, VolumeUnit } from '@/enums/sale'
	import { generateUUID } from '@/plugins/helper'
	import ProductFloatingBarcodes from '@/components/form/product/product-floating-barcodes.vue'
	import ProductBarcodePrices from '@/components/form/product/product-barcode-prices.vue'
	import GenerateBarcodesByPattern from '@/components/form/barcode/generate-barcodes.vue'
	import { PrintDataConvertTypes } from '@/plugins/stimul'

	export default {
		name: 'product-modify',
		modal: {
			size: 'lg',
			stateUID: 'product-modify',
			helpTag: 'ProductModify'
		},
		props: {
			data: { type: Object },
			options: { type: Object },
		},
		components: {
			productCardex: () => import('~/views/reports/product-cardex.vue'),
		},
		data() {
			return {
				originalProduct: null,
				settings: {},
				percentOptions: {
					mode: 'percent',
					icon: 'percent',
				},
				stock: [],
				priceTableToggler: true,
				orderPointToggler: true,
				floatingTableToggler: true,
				productFloatingJson: [],
				pricesTableData: [],
				barcodePricesTableData: [],
				selectedBarcodePriceRow: null,
				orderPointTableData: [],
				floatingsTableData: [],
				stocksTableData: [],
				localData: this.getDefaultData(),
				componentOptions: {
					imageUploader: {
						image: {
							height: 80,
							width: 80,
							defaultImage: 'product',
						}
					},
					code: {
						searchable: true,
						mode: 'string',
						onSearchClick: this.allProducts,
					},
					string: {
						mode: 'string',
					},
					kind: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return this.$t(item.group + '.' + item.key.toLowerCase())
						},
						searchableFields: ['key'],
						searchPrefix: 'ProductKindes',
					},
					group: {
						hideParents: true,
					},
					classification: {},
					warehouse: {},
					barcodes: {
						name: 'barcodes',
						allowNewRow: true,
						activeRowDisabled: false,
						editable: true,
						addNewRowOnInit: false,
						displayOrderEnabled: false,
						row_ID: 'id',
						buttons: {
							addBtn: {
								options: {
									visible: true,
									isPrimary: false,
								}
							},
							deleteBtn: {
								options: {
									visible: true
								}
							},
							generateByPatternBtn: {
								handler: this.showGenerateBarcodes,
								displayOrder: 60,
								type: 'nk-btn',
								options: {
									isPrimary: false,
									//shortcut: $sc.find('sum-till-current-row', 'table'),
									hideShortcut: true,
									title: this.$t('sale.product.f.productBarcode.generateByPattern'),
									visible: true,
									icon: 'barcode',
									tooltipEnabled: true,
									hideTitle: false,
								}
							}
						},
						prepareNewRow: () => {
							return {
								codeType: null,
								code: 0,
								isMain: false,
								productId: this.localData.id
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px',
								entering: false,
								pinned: false,
								pinnable: true
							},
							{
								name: 'codeType',
								title: this.$t('sale.product.f.productBarcode.codeType'),
								width: 300,
								editable: true,
								buttons: {
									addBtn: {
										options: {
											visible: true,
											isPrimary: false,
										}
									},
									deleteBtn: {
										options: {
											visible: true
										}
									}
								},
								view: {
									options: {
										format: (item) => {
											return this.$t('sale.product.barcode-type.' + item)
										}
									},
								},
								edit: (row, col) => {
									return {
										component: Dropdown,
										options: {
											selectorWidth: '300px',
											rowIdentifier: 'id',
											getDataFromOptions: true,
											locateSelectorBasedOnDocument: true,
											display: (item) => {
												return this.$t('sale.product.barcode-type.' + item)
											},
											data: this.barcodes.map((x) => x.key),
										},
									}
								},
								entering: true,
								validators: validators('required'),
								changeExperimenter: (obj, otherObj, key) => {
									if (key == null) {
										if (obj != null && otherObj != null) {
											return obj.id === otherObj.id
										}
									}
								}
							},
							{
								name: 'code',
								title: this.$t('sale.product.f.productBarcode.code'),
								type: 'number',
								edit: {
									component: Input,
									options: {
										mode: 'strnumber',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: 'auto',
							},
							{
								name: 'isMain',
								title: this.$t('sale.product.f.productBarcode.isMain'),
								type: 'dropdown',
								search: {
									prefix: 'boolean-yes-no',
									useTranslate: true,
								},
								view: {
									component: BooleanView,
									options: {
										useColors: true,
									},
								},
								edit: {
									component: Switch,
									options: {
										mode: 'number',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: '>100',
							},
						],
					},
					prices: {
						searchable: false,
						activeRowDisabled: false,
						editable: true,
						addNewRowOnInit: false,
						displayOrderEnabled: false,
						buttons: {
							getLastPrices: {
								handler: this.getLastPrices,
								displayOrder: 1,
								type: 'nk-btn',
								options: {
									isPrimary: true,
									shortcut: $sc.find('sum-till-current-row', 'table'),
									hideShortcut: true,
									title: this.$t('sale.product.f.productPrice.getLastPrices'),
									visible: true,
									icon: 'badge-dollar',
									tooltipEnabled: true,
									hideTitle: false,
								}
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px',
								entering: false,
								pinned: false,
								pinnable: true,
							},
							{
								name: 'productFloatingJson',
								title: this.$t('sale.product.f.productPrice.floatingsJson'),
								type: 'string',
								entering: false,
								editable: false,
								width: '300px',
								view: {
									options: {
										format: (item) => {
											item = item.productFloatingValues
											if (_.isEmpty(item)) {
												return this.$t('sale.product.f.withoutFloating')
											}

											let title = ''
											item.forEach((floating, index) => {
												title += floating.title + (index < item.length - 1 ? ' | ' : '')
											})
											return title
										}
									},
								},
								search: {
									searchFields: ['productFloatingValues'],
									subSearchField: ['title']
								},
							},
							{
								name: 'lastBuyPrice',
								title: this.$t('sale.product.f.productPrice.lastBuyPrice'),
								editable: false,
								width: 'auto',
								pinned: true,
								entering: false,
								pinnable: false,
								type: 'string',
								align: 'right',
								view: {
									options: {
										type: 'price',
										format: (item) => item
									}
								}
							},
							{
								name: 'lastSalePrice',
								title: this.$t('sale.product.f.productPrice.lastSellPrice'),
								editable: false,
								entering: false,
								width: 'auto',
								pinned: true,
								pinnable: false,
								type: 'string',
								align: 'right',
								view: {
									options: {
										type: 'price',
										format: (item) => item
									}
								}
							}
						],
					},
					barcodePrices: {
						searchable: true,
						activeRowDisabled: false,
						editable: true,
						allowNewRow: false,
						alwaysEmit: true,
						displayOrderEnabled: false,
						row_ID: 'id',
						buttons: {
							submitPriceBtn: {
								id: this.idGenerator(5),
								displayOrder: 1,
								handler: this.showBarcodePricesModal,
								class: "no-outline",
								type: 'nk-btn',
								options: {
									isPrimary: false,
									title: this.$t('sale.product.f.barcodePrices.submitPrice'),
									visible: true,
									icon: 'badge-dollar',
									tooltipEnabled: true,
									hideTitle: false,
									element: () => this.$refs.barcodePricesTable?.$el,
								}
							},
							deleteBtn: {
								id: this.idGenerator(5),
								displayOrder: 2,
								handler: this.clearBarcodePrices,
								class: "no-outline",
								type: 'nk-btn',
								options: {
									isPrimary: false,
									title: this.$t('sale.product.f.barcodePrices.deletePrices'),
									visible: true,
									icon: 'trash',
									tooltipEnabled: true,
									hideTitle: false,
									element: () => this.$refs.barcodePricesTable?.$el,
								}
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px',
								entering: false,
								pinned: false,
								pinnable: true,
							},
							{
								name: 'barcode',
								title: this.$t('sale.product.f.barcodePrices.barcode'),
								editable: false,
								entering: false,
								type: 'string',
								width: '250px',
								searchable: true,
								sortable: true,
								align: 'right',
							},
							{
								name: 'productFloatingJsonName',
								title: this.$t('sale.product.f.barcodePrices.productFloatingJson'),
								editable: false,
								entering: false,
								type: 'string',
								width: '300px',
								searchable: true,
								sortable: true,
								align: 'right',
							},
							{
								name: 'prices',
								title: this.$t('sale.product.f.barcodePrices.prices'),
								editable: false,
								entering: false,
								type: 'string',
								width: 'auto',
								searchable: true,
								sortable: false,
								align: 'right',
								search: {
									filter: (data, col) => {
										const rawKeyword = (col.search?.keyword?.start || '').toString().trim()
										if (!rawKeyword) return data

										const cleanKeyword = rawKeyword.toEnglishDigits().trim().toLowerCase()
										const noCommaKeyword = cleanKeyword.replace(/,/g, '').replace(/،/g, '').replace(/ /g, '')
										const filterType = col.search?.filterType

										const match = (raw, formatted) => {
											switch (filterType) {
												case '===':
													return raw === noCommaKeyword || formatted === cleanKeyword || raw === cleanKeyword
												case 'startWith':
													return raw.startsWith(noCommaKeyword) || formatted.startsWith(cleanKeyword) || raw.startsWith(cleanKeyword)
												case 'endWith':
													return raw.endsWith(noCommaKeyword) || formatted.endsWith(cleanKeyword) || raw.endsWith(cleanKeyword)
												case 'indexOf':
												default:
													return raw.includes(noCommaKeyword) || formatted.includes(cleanKeyword) || raw.includes(cleanKeyword)
											}
										}

										return data.filter((row) => {
											const prices = row[col.name]
											if (!prices || !Array.isArray(prices) || prices.length === 0) {
												if (rawKeyword === '-' && (filterType === '===' || !filterType || filterType === 'indexOf')) {
													return true
												}
												return false
											}

											const priceMatched = prices.some((p) => {
												const rawPrice = String(p).toEnglishDigits()
												const formattedPrice = Number(p).toLocaleString().toEnglishDigits()
												return match(rawPrice, formattedPrice)
											})
											if (priceMatched) return true

											const fullFormatted = prices.map((p) => Number(p).toLocaleString().toEnglishDigits()).join(' | ')
											const fullRaw = prices.map((p) => String(p).toEnglishDigits()).join(' | ')
											return match(fullRaw, fullFormatted)
										})
									}
								},
								view: {
									options: {
										format: (item) => {
											if (!item || !Array.isArray(item) || item.length === 0) return '-'
											return item.map(x => Number(x).toLocaleString()).join(' | ')
										}
									}
								}
							}
						],
					},
					orderPoints: {
						searchable: false,
						activeRowDisabled: false,
						editable: true,
						addNewRowOnInit: false,
						displayOrderEnabled: false,
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px',
								entering: false,
								pinned: false,
								pinnable: true,
							},
							{
								name: 'productFloatingJson',
								title: this.$t('sale.product.f.productPrice.floatingsJson'),
								type: 'string',
								entering: false,
								editable: false,
								width: '300px',
								view: {
									options: {
										format: (item) => {
											item = item.productFloatingValues
											if (_.isEmpty(item)) {
												return this.$t('sale.product.f.withoutFloating')
											}

											let title = ''
											item.forEach((floating, index) => {
												title += floating.title + (index < item.length - 1 ? ' | ' : '')
											})
											return title
										}
									},
								},
								search: {
									searchFields: ['productFloatingValues'],
									subSearchField: ['title']
								},
							},
						],
					},
					units: {
						activeRowDisabled: false,
						editable: true,
						addNewRowOnInit: false,
						allowNewRow: true,
						row_ID: 'id',
						displayOrderEnabled: false,
						buttons: {
							addBtn: {
								options: {
									visible: true,
									isPrimary: false,
								}
							},
							deleteBtn: {
								options: {
									visible: true
								}
							}
						},
						prepareNewRow: () => {
							return {
								unit: null,
								name: '',
								rate: 1,
								isPrimary: this.$refs.unitTable.clonedData.length === 0 ? true : false,
								companyId: emptyId,
								productId: emptyId,
								weight: 0,
								weightUnit: WeightUnit.Unknown,
								volume: 0,
								volumeUnit: VolumeUnit.Unknown,
								width: 0,
								widthUnit: DimensionUnit.Unknown,
								length: 0,
								lengthUnit: DimensionUnit.Unknown,
								height: 0,
								heightUnit: DimensionUnit.Unknown,
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px|>70px',
								entering: false,
								pinned: true,
								pinnable: false
							},
							{
								name: 'unit',
								title: this.$t('sale.product.f.productUnit.unit'),
								width: 200,
								editable: true,
								search: {
									searchFields: ['name'],
								},
								view: {
									options: {
										format: (item) => item.name,
									},
								},
								edit: (row, col) => {
									return {
										component: DropdownProductMeasureUnit,
										options: {
											dropdownOptions: {
												onChangeHandler(item) {
													row.name = item.name
												},
											}
										},
									}
								},
								entering: true,
								leaving: true,
								validators: validators('required'),
								changeExperimenter: (obj, otherObj, key) => {
									if (key == null) {
										if (obj != null && otherObj != null) {
											return obj.id === otherObj.id
										}
									}
								},
							},
							{
								name: 'name',
								title: this.$t('sale.product.f.productUnit.name'),
								type: 'string',
								edit: {
									component: Input,
									options: {
										mode: 'string',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: 200,
							},
							{
								name: 'rate',
								title: this.$t('sale.product.f.productUnit.rate'),
								type: 'number',
								edit: {
									component: Input,
									options: {
										mode: 'float',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: 250,
							},
							{
								name: 'weight',
								title: this.$t('sale.product.f.productUnit.weight'),
								width: 150,
								editable: true,
								search: {
									searchFields: ['weight', 'weightUnit'],
								},
								view: (row) => ({
									options: {
										format: () => {
											return `${row.weight} ${this.$t(`enum-items.WeightUnits.${row.weightUnit}`)}`
										},
									},
								}),
								edit: (row, col) => {
									return {
										component: DropdownInput,
										options: {
											resolveNames: ['weight', 'weightUnit'],
											inputSize: { sm: 4 },
											dropdownSize: { sm: 8 },
											readValueFromOptions: true,
											value: () => { return { weight: row.weight, weightUnit: row.weightUnit } },
											dropdownItems: Object.values(WeightUnit),
											dropdownOptions: {
												display: (item) => this.$t(`enum-items.WeightUnits.${item}`)
											},
											onChangeHandlers: {
												input: (val) => {
													row.weight = val.weight
												},
												dropdown: (val) => {
													row.weight = val.weight
													row.weightUnit = val.weightUnit
												}
											}
										},
									}
								},
								entering: true,
								leaving: true,
								validators: validators(
									new VCustom(
										(val, row) => {
											return val && val > 0 ? row.weightUnit !== WeightUnit.Unknown : true
										},
										() => this.$t('msg.required', [this.$t('sale.product.f.productUnit.set-unit-for-dimension', { name: this.$t('sale.product.f.productUnit.weight') })])
									)),
							},
							{
								name: 'volume',
								title: this.$t('sale.product.f.productUnit.volume'),
								width: 150,
								editable: true,
								search: {
									searchFields: ['volume', 'volumeUnit'],
								},
								view: (row) => ({
									options: {
										format: () => {
											return `${row.volume} ${this.$t(`enum-items.VolumeUnits.${row.volumeUnit}`)}`
										},
									},
								}),
								edit: (row, col) => {
									return {
										component: DropdownInput,
										options: {
											resolveNames: ['volume', 'volumeUnit'],
											inputSize: { sm: 4 },
											dropdownSize: { sm: 8 },
											readValueFromOptions: true,
											value: () => { return { volume: row.volume, volumeUnit: row.volumeUnit } },
											dropdownItems: Object.values(VolumeUnit),
											dropdownOptions: {
												display: (item) => this.$t(`enum-items.VolumeUnits.${item}`)
											},
											onChangeHandlers: {
												input: (val) => {
													row.volume = val.volume
												},
												dropdown: (val) => {
													row.volume = val.volume
													row.volumeUnit = val.volumeUnit
												}
											}
										},
									}
								},
								entering: true,
								leaving: true,
								validators: validators(
									new VCustom(
										(val, row) => {
											return val && val > 0 ? row.volumeUnit !== VolumeUnit.Unknown : true
										},
										() => this.$t('msg.required', [this.$t('sale.product.f.productUnit.set-unit-for-dimension', { name: this.$t('sale.product.f.productUnit.volume') })])
									)),
							},
							{
								name: 'width',
								title: this.$t('sale.product.f.productUnit.width'),
								width: 150,
								editable: true,
								search: {
									searchFields: ['width', 'widthUnit'],
								},
								view: (row) => ({
									options: {
										format: () => {
											return `${row.width} ${this.$t(`enum-items.DimensionUnits.${row.widthUnit}`)}`
										},
									},
								}),
								edit: (row, col) => {
									return {
										component: DropdownInput,
										options: {
											resolveNames: ['width', 'widthUnit'],
											inputSize: { sm: 4 },
											dropdownSize: { sm: 8 },
											readValueFromOptions: true,
											value: () => { return { width: row.width, widthUnit: row.widthUnit } },
											dropdownItems: Object.values(DimensionUnit),
											dropdownOptions: {
												display: (item) => this.$t(`enum-items.DimensionUnits.${item}`)
											},
											onChangeHandlers: {
												input: (val) => {
													row.width = val.width
												},
												dropdown: (val) => {
													row.width = val.width
													row.widthUnit = val.widthUnit
												}
											}
										},
									}
								},
								entering: true,
								leaving: true,
								validators: validators(
									new VCustom(
										(val, row) => {
											return val && val > 0 ? row.widthUnit !== DimensionUnit.Unknown : true
										},
										() => this.$t('msg.required', [this.$t('sale.product.f.productUnit.set-unit-for-dimension', { name: this.$t('sale.product.f.productUnit.width') })])
									)),
							},
							{
								name: 'height',
								title: this.$t('sale.product.f.productUnit.height'),
								width: 150,
								editable: true,
								search: {
									searchFields: ['height', 'heightUnit'],
								},
								view: (row) => ({
									options: {
										format: () => {
											return `${row.height} ${this.$t(`enum-items.DimensionUnits.${row.heightUnit}`)}`
										},
									},
								}),
								edit: (row, col) => {
									return {
										component: DropdownInput,
										options: {
											resolveNames: ['height', 'heightUnit'],
											inputSize: { sm: 4 },
											dropdownSize: { sm: 8 },
											readValueFromOptions: true,
											value: () => { return { height: row.height, heightUnit: row.heightUnit } },
											dropdownItems: Object.values(DimensionUnit),
											dropdownOptions: {
												display: (item) => this.$t(`enum-items.DimensionUnits.${item}`)
											},
											onChangeHandlers: {
												input: (val) => {
													row.height = val.height
												},
												dropdown: (val) => {
													row.height = val.height
													row.heightUnit = val.heightUnit
												}
											}
										},
									}
								},
								entering: true,
								leaving: true,
								validators: validators(
									new VCustom(
										(val, row) => {
											return val && val > 0 ? row.heightUnit !== DimensionUnit.Unknown : true
										},
										() => this.$t('msg.required', [this.$t('sale.product.f.productUnit.set-unit-for-dimension', { name: this.$t('sale.product.f.productUnit.height') })])
									)),
							},
							{
								name: 'length',
								title: this.$t('sale.product.f.productUnit.length'),
								width: 150,
								editable: true,
								search: {
									searchFields: ['length', 'lengthUnit'],
								},
								view: (row) => ({
									options: {
										format: () => {
											return `${row.length} ${this.$t(`enum-items.DimensionUnits.${row.lengthUnit}`)}`
										},
									},
								}),
								edit: (row, col) => {
									return {
										component: DropdownInput,
										options: {
											resolveNames: ['length', 'lengthUnit'],
											inputSize: { sm: 4 },
											dropdownSize: { sm: 8 },
											readValueFromOptions: true,
											value: () => { return { length: row.length, lengthUnit: row.lengthUnit } },
											dropdownItems: Object.values(DimensionUnit),
											dropdownOptions: {
												display: (item) => this.$t(`enum-items.DimensionUnits.${item}`)
											},
											onChangeHandlers: {
												input: (val) => {
													row.length = val.length
												},
												dropdown: (val) => {
													row.length = val.length
													row.lengthUnit = val.lengthUnit
												}
											}
										},
									}
								},
								entering: true,
								leaving: true,
								validators: validators(
									new VCustom(
										(val, row) => {
											return val && val > 0 ? row.lengthUnit !== DimensionUnit.Unknown : true
										},
										() => this.$t('msg.required', [this.$t('sale.product.f.productUnit.set-unit-for-dimension', { name: this.$t('sale.product.f.productUnit.length') })])
									)),
							},
							{
								name: 'isPrimary',
								title: this.$t('sale.product.f.productUnit.isPrimary'),
								type: 'dropdown',
								search: {
									prefix: 'boolean-yes-no',
									useTranslate: true,
								},
								view: {
									component: BooleanView,
									options: {
										useColors: true,
									},
								},
								edit: {
									component: Switch,
									options: {
										mode: 'number',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: '>100',
							},
						],
					},
					productCostFormulaItems: {
						activeRowDisabled: false,
						editable: true,
						allowNewRow: true,
						addNewRowOnInit: false,
						row_ID: 'id',
						buttons: {
							addBtn: {
								options: {
									visible: true,
									isPrimary: false,
								}
							},
							deleteBtn: {
								options: {
									visible: true
								}
							}
						},
						prepareNewRow: () => {
							return {
								operatorFloatingCenter: null,
								amount: 0,
								percent: '',
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px|>70px',
								entering: false,
								pinned: true,
								pinnable: false,
							},
							{
								name: 'temp_floatings',
								title: this.$t(
									'sale.product.f.productCostFormula.operatorCenter'
								),
								width: 'auto|>250px|<800px',
								editable: true,
								autoGrowWidth: true,
								validators: validators('required'),
								view: {
									component: FloatingCenterMultichoice,
									options: {
										wrap: false,
										editable: false,
									},
								},
								edit: (row, col) => {
									return {
										component: FloatingCenterMultichoice,
										options: {
											wrap: false,
											editable: true,
											maxSelectedCount: 1,
											dropdown: {
												selectorWidth: 400,
												locateSelectorBasedOnDocument: true,
											},
											//formName: FORM_NAME,
										},
									}
								},
								searchable: true,
								sortable: false,
								entering: (row, col) => {
									row.temp_floatings =
										row.temp_floatings ||
										[].concat(row.operatorFloatingCenter || [])
									return true
								},
								leaving: (row, col) => {
									row.operatorFloatingCenter = _.head(row.temp_floatings)
									this.defer(() => {
										// this.$refs.formulaTable.col_recalculateWidth(row, col.id)
									}, 0)
									return true
								},
								changeExperimenter: (obj, otherObj, key) => {
									if (key == null) {
										if (obj != null && otherObj != null) {
											return obj.id === otherObj.id
										}
									}
								},
							},
							{
								name: 'amount',
								title: this.$t('sale.product.f.productCostFormula.amount'),
								type: 'price',
								view: {
									options: {
										type: 'price',
									},
								},
								edit: {
									component: Input,
									options: {
										mode: 'price',
										useDefaultValue: true,
									},
								},
								leaving: (row, col) => {

									if (row.amount)
										row.percent = 0

									return true
								},
								editable: true,
								width: 200,
								validators: validators(
									new VGreaterThan(-1, true),
									new VRequiredIfEmpty('percent')
								),
								entering: true,
							},
							{
								name: 'percent',
								title: this.$t('sale.product.f.productCostFormula.percent'),
								type: 'number',
								view: {
									options: {
										format: (perc) => `%${perc}`,
									},
								},
								edit: {
									component: Input,
									options: {
										mode: 'percent',
									},
								},
								editable: true,
								entering: true,
								validators: validators(
									new VLessThan(100, true),
									new VRequiredIfEmpty('amount')
								),
								leaving: (row, col) => {

									if (row.percent)
										row.amount = 0

									return true
								},
								width: 180,
							},
						],
					},
					floatings: {
						activeRowDisabled: false,
						editable: true,
						searchable: false,
						allowNewRow: false,
						alwaysEmit: true,
						displayOrderEnabled: true,
						buttons: {
							addBtn: {
								options: {
									visible: true,
								}
							},
							deleteBtn: {
								options: {
									visible: true,
								}
							},
							barcodesBtn: {
								id: this.idGenerator(5),
								displayOrder: 10,
								handler: this.showBarcodesList,
								class: "no-outline",
								type: 'nk-btn',
								options: {
									visible: true,
									isPrimary: false,
									icon: 'barcode',
									tooltipEnabled: true,
									hideTitle: false,
									title: this.$t('sale.product.f.edit-barcodes'),
									shortcut: { keyCode: 66, ctrlKey: true }, // 66:B
									element: () => this.$refs.floatingTable?.$el,
									hideShortcut: true,
								}
							},
							generateByPatternBtn: {
								handler: this.showGenerateFloatingBarcodes,
								displayOrder: 15,
								type: 'nk-btn',
								options: {
									isPrimary: false,
									//shortcut: $sc.find('sum-till-current-row', 'table'),
									hideShortcut: true,
									title: this.$t('sale.product.f.productBarcode.generateForAll'),
									visible: true,
									icon: 'barcode',
									tooltipEnabled: true,
									hideTitle: false,
								}
							}
						},
						allowNewRow: true,
						row_ID: 'uid',
						prepareNewRow: () => {
							return {
								id: this.generateUUID()
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px',
								entering: false,
								pinned: false,
								pinnable: true,
							},
						],
					},
					stock: {
						editable: false,
						searchable: true,
						activeRowDisabled: true,
						displayOrderEnabled: false,
						aggregatesEnabled: true,
						buttons: {
							getWarehouseStocks: {
								handler: () => { this.fillStockData('warehouse') },
								displayOrder: 1,
								type: 'nk-btn',
								options: {
									isPrimary: true,
									shortcut: $sc.find('sum-till-current-row', 'table'),
									hideShortcut: true,
									title: this.$t('sale.product.f.get-warehouse-stocks'),
									visible: true,
									//icon: 'badge-dollar',
									tooltipEnabled: true,
									hideTitle: false,
								}
							},
							getFactorStocks: {
								handler: () => { this.fillStockData('factor') },
								displayOrder: 2,
								type: 'nk-btn',
								options: {
									isPrimary: true,
									shortcut: $sc.find('sum-till-current-row', 'table'),
									hideShortcut: true,
									title: this.$t('sale.product.f.get-factor-stocks'),
									visible: true,
									//icon: 'badge-dollar',
									tooltipEnabled: true,
									hideTitle: false,
								}
							},
							showProductCardex: {
								handler: this.showCardex,
								displayOrder: 3,
								type: 'nk-btn',
								options: {
									disabled: true,
									isPrimary: true,
									// shortcut: $sc.find('sum-till-current-row', 'table'),
									hideShortcut: true,
									title: this.$t('reports.product-cardex.title'),
									visible: true,
									//icon: 'badge-dollar',
									tooltipEnabled: true,
									hideTitle: false,
								}
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								searchable: true,
								sortable: true,
								editable: false,
								entering: false,
								pinned: true,
								pinnable: false,
								resizable: false,
								width: '50px',
							},
							{
								name: 'joinedFloatingNames',
								title: this.$t('sale.product.f.productPrice.floatingsJson'),
								type: 'string',
								editable: false,
								width: '300px',
							},
						],
					},
					addMetaDataButton: {
						title: this.$t('sale.product.f.define-additional-fields'),
						icon: 'plus',
						isPrimary: true
					},
					relatableWarehouses: {
						activeRowDisabled: true,
						editable: true,
						searchable: false,
						buttons: {
							addBtn: {
								options: {
									visible: true,
								}
							},
							deleteBtn: {
								options: {
									visible: true,
								}
							}
						},
						allowNewRow: true,
						prepareNewRow: () => {
							return {
								code: '',
								name: '',
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								searchable: true,
								sortable: true,
								editable: false,
								entering: false,
								pinned: true,
								pinnable: false,
								resizable: false,
								width: '10%',
							},
							{
								name: 'warehouse',
								title: this.$t('sale.warehouse.f.name'),
								view: {
									options: {
										format: (item) => `${item && item.name ? item.name : ''} (${item && item.code ? item.code : ''})`,
									},
								},
								edit: (row, col) => {
									return {
										component: WarehouseDropdown,
										options: {
											searchFields: ['SearchValue'],
											displayFields: ['code', 'name'],
											dropdownOptions: {
												placeholder: this.$t('select-it'),
												searchableFields: ['name', 'code'],
											}
										},
									}
								},
								align: 'right',
								searchable: true,
								sortable: false,
								editable: true,
								validators: validators('required'),
								width: 'auto',

							},
						],
					},
				},
				kind: [],
				barcodes: [],
				productPriceLevels: [],
				floatings: [],
				relatableWarehouses: [],
				activeTab: 'product-unit',
				selectedItem: null,
				selectedFloatingRow: null,
				selectedRow: null,
				validators: {
					localData: {
						name: validators('required'),
						productGroup: validators('required'),
						kind: validators('required'),
						isEnabled: validators('required'),
						isSerialized: validators('required'),
						moadianCode: validators(
							new VCustom(
								(val, row) => {
									return !val || val.length === 13
								},
								() => this.$t('sale.product.m.moadianCode-length-13')
							)),
					},
				},

				settings_button: {
					title: this.$t('setting.productSettings.title'),
					handle: (button, page, e) => {
						this.showModal({
							component: SaleSettings,
							options: {
								form: 'Product'
							}
						})
							.then(() => { })
							.catch(() => { })
					},
					icon: 'cog',
					policyClaims: 'Settings_SaleBuy_SaleBuy',
				},
				button_snapshot: {
					type: 'snapshot',
					options: () => {
						return {
							fillData: this.fillProduct,
							snapshotInstance: this.snapshotInstance
						}
					}
				},
				metaDataBtn: {
					icon: 'list-ul',
					handle: (button, page, e) => {
						this.metaDataModal()
					},
					policyClaims: 'General_MetaDataSchema_Management'
				},
				deleteProductButton: {
					title: this.$t('sale.product.delete'),
					shortcut: $sc.find('delete'),
					visible: true,
					icon: 'trash',
					handle: (button, page, e) => {
						e.preventDefault()
						this.showDeleteProductDialog(this.localData)
					},
					policyClaims: 'Product_Product_Delete',
				},
				saveProductButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					handle: () => {
						this.trySaveProduct()
					},
					icon: 'save',
					policyClaims: { or: ['Product_Product_Edit', 'Product_Product_Add'] },
				},
				newProductButton: {
					title: this.$t('new'),
					shortcut: $sc.find('new'),
					icon: 'plus',
					isPrimary: false,
					handle: (button, page, e) => {
						this.clearBoard()
					},
					policyClaims: 'Product_Product_Add',
				},
				buttons_prev: {
					title: this.$t('sale.product.nav.prev'),
					shortcut: $sc.find('ctrl-move-down', 'table'),
					handle: (button, page, e) => {
						this.loadIfPossible(null, true, { direction: 'previous', id: this.localData.id })
					},
					icon: 'angle-right',
					beginOfGroup: true,
				},
				buttons_next: {
					title: this.$t('sale.product.nav.next'),
					shortcut: $sc.find('ctrl-move-up', 'table'),
					handle: (button, page, e) => {
						this.loadIfPossible(null, true, { direction: 'next', id: this.localData.id })
					},
					icon: 'angle-left',
				},
				changeCodeButton: {
					title: this.$t('changeCode.title'),
					shortcut: $sc.find('edit'),
					isPrimary: false,
					disabled: true,
					icon: 'code',
					handle: (button, page, e) => {
						e.preventDefault()
						this.showModal({
							component: UpdateCode,
							options: {
								claim: 'Product_Product_Edit',
								commercialAccess: ['Sale', 'Warehouse'],
							},
							data: { code: this.localData.code }
						}).then(res => {
							this.localData.code = res.code
							this.saveProduct()
								.then((res) => { })
								.catch(err => { this.localData.code = this.originalProduct.code })
						}).catch(err => { })

					},
					policyClaims: ['Product_Product_Edit'],
				},
				printButton: {
					type: 'print',
					form: 'Product',
					claimPrefix: 'Product_Product_',
					getDataSources: () => this.print_dataSources(),
					disabled: false,
				},

			}
		},
		computed: {
			...mapGetters({
				metaDataList: 'metadata/schemas',
				getProductFloatingList: 'productFloatings/all',
				getWarehousesList: 'warehouses/all',
			}),
			productKind: {
				get() {
					return _.head(
						this.kind.filter(
							(x) => _.toLower(x.key) === _.toLower(this.localData.kind)
						)
					)
				},
				set(obj) {
					this.localData.kind = obj.key
				},
			},
			metaDataListOptions() {
				return {
					subject: (this.localData.productGroup || {}).name || '',
					data: this.localData.metaDatas || [],
					prefix: 'Product',
					labelSizes: { sm: 12 },
					dataSizes: { sm: 12 },
					labelAligns: { sm: 'right', md: 'right', lg: 'right' },
					columnSize: 4,
				}
			},
		},
		watch: {
			'localData.isTaxFree': {
				handler(val) {
					this.defer(this.registerTabOrders, 500)
				}
			},
			getWarehousesList: {
				handler(val) {
					this.appendWarehousesToOrderPointTable()
				}
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			if (this.data)
				this.fillProduct(this.data)
			else if (this.settings.code)
				this.getProductByCode({ searchCode: this.settings.code }).then((result) => { this.fillProduct(result) })
			else if (this.settings.id)
				this.getProductById(this.settings.id).then((result) => { this.fillProduct(result) })
			else
				this.clearForm()

			this.loadRelatableWarehouses()
			this.refreshProductFloatings()
			this.refreshWarehouses()
			this.getProperties()
			this.getProductFloatings()
			this.fillProduct(this.localData)
			this.loadProductPriceLevels()
			this.createWarehouseColumns()
			this.prepareWindow(this.$t('sale.product-modify.title'), [
				this.saveProductButton,
				this.newProductButton,
				this.deleteProductButton,
				this.changeCodeButton,
				{ type: 'seprator' },
				this.printButton,
				{ type: 'excel', module: 'sale', hideExport: true, mapSettings: { type: 'Product' } },
			])
		},
		methods: {
			...mapActions({
				broadcastItemExist: 'socket/broadcastItemExist',
				refreshProductFloatings: 'productFloatings/refresh',
				refreshWarehouses: 'warehouses/refresh',
			}),
			setFormMode(product = this.localData) {

				if (!this.options || !this.options.mode)
					this.settings.mode = this.FORM_MODES.EDITABLE

				this.saveProductButton.disabled = this.settings.mode === this.FORM_MODES.READONLY
				this.deleteProductButton.disabled = this.settings.mode === this.FORM_MODES.READONLY || product.id === emptyId
			},
			snapshot() {
				return {
					form: 'product-modify',
					isDataChanged: this.isDataChanged,
					retrieveData: () => {
						var snap = _.cloneDeep(this.localData)

						if (this.$refs && this.$refs.barcodeTable && this.$refs.unitTable && this.$refs.priceTable && this.$refs.metaDataList && this.$refs.floatingTable) {
							snap.barcodes = this.$refs.barcodeTable.getTableData().data
							snap.productFloatingJsons = this.$refs.floatingTable.getTableData().data
							snap.prices = this.$refs.priceTable.getTableData().data
							snap.units = this.$refs.unitTable.getTableData().data
							snap.formulas = []
							snap.metaDatas = this.$refs.metaDataList.commitData()
							snap.barcodePrices = this.prepareBarcodePricesForSave()
						}

						return snap
					}
				}
			},
			showDeleteProductDialog(productInfo) {
				if (!this.localData || !this.localData.id || this.localData.id === emptyId) {
					this.$toast(this.$t('sale.product.m.select-one-product'), { type: 'error' })
					return
				}
				dialog({
					title: this.$t('sale.product.delete'),
					body: this.$t('sale.product.m.want-to-delete-product', {
						name: productInfo.name,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteProduct(productInfo)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteProduct(product) {
				var wait = this.$wait(this.grandParent, { size: 'small' })
				post(Endpoints.getUrl('sale.product.delete'), { Id: product.id })
					.then((result) => {
						wait.end()
						this.$toast(this.$t('sale.product.m.product-delete-success', { code: product.code }), { type: 'success' })
						this.clearForm()
					})
					.catch(() => {
						wait.end()
					})
			},
			loadIfPossible(code, useToast = true, navigateOptions, forceLoad) {

				let methods = {
					retreiveIsEmpty: this.retreiveIsEmpty,
					fillData: this.fillProduct,
					getData: this.getProductByCode,
					clearForm: this.clearForm,
					changedFormAlert: this.changedFormAlert,
					isDataChanged: this.isDataChanged,
					navigate: this.NavigateToProduct,
					save: this.saveProduct,
					forceLoad: () => forceLoad,
					formType: () => this.$options.name
				}

				let data = {
					originalData: this.originalProduct,
					searchCode: code
				}
				this.$nikan.formUtility.loadIfPossible(methods, data, { keyword: 'کالا', useToast: useToast }, navigateOptions)
			},
			taxChanged(val) {
				this.localData.isTollFree = val
				this.localData.isTaxFree = val
			},
			showFloatingList() {
				this.showModal({
					component: ProductFloatingList,
				})
					.then(() => { })
					.catch(() => { })
			},
			getLastPrices() {
				var wait = this.$wait(this.$refs.priceTable.$el)
				post(Endpoints.getUrl('sale.product.get-last-price'), { productId: this.localData.id })
					.then(res => {
						let clonedPricesTableData = _.cloneDeep(this.pricesTableData)
						clonedPricesTableData.forEach(priceTableDataRow => {
							let lastBuy = res.data.lastBuyPrices.items.find(x => this.generateKeyFromValues(x.productFloatingValues) == this.generateKeyFromValues(priceTableDataRow.productFloatingJson.productFloatingValues))
							let lastSale = res.data.lastSalePrices.items.find(x => this.generateKeyFromValues(x.productFloatingValues) == this.generateKeyFromValues(priceTableDataRow.productFloatingJson.productFloatingValues))
							priceTableDataRow.lastBuyPrice = lastBuy ? lastBuy.price : 'موردی یافت نشد'
							priceTableDataRow.lastSalePrice = lastSale ? lastSale.price : 'موردی یافت نشد'
						})
						this.pricesTableData = clonedPricesTableData
						wait.end()
					}).catch(err => { wait.end() })
			},
			registerTabOrders() {
				TabOrder.subscribeKeys(this.grandParentType(), this)
			},
			metaDataModal() {
				if (!this.localData.productGroup || !this.localData.productGroup.name)
					return this.$toast(this.$t('meta-data.select-group'))
				this.showModal({
					component: MetaDataSchemaModify,
					options: {
						subject: (this.localData.productGroup || {}).name || '',
						title: (this.localData.productGroup || {}).name || '',
						prefix: 'Product',
						addSystemFieldConnector: false,
					},
				}).then((res) => {
					this.$refs.metaDataList.refresh()
				}).catch(() => { })
			},
			fillStockData(type) {
				if (this.retreiveIsEmpty()) {
					this.$toast(this.$t('sale.product.m.select-one-product'), { type: 'info' })
					return
				}
				let data = {
					productId: this.localData.id,
				}
				let url = type == 'factor' ? Endpoints.getUrl('sale.product.get-product-stock') : Endpoints.getUrl('sale.product.get-product-warehouse-stock')
				let wait = this.$wait(this.$refs.stockTable.$el)
				post(url, data).then((res) => {
					let stocks = res.data.items
					var finalData = []

					for (var stock of stocks) {
						for (var floating of stock.floatingStocks) {

							var tmp = {
								id: this.generateUUID(),
								joinedFloatingNames: floating.joinedFloatingNames || this.$t('sale.factor.no-floating')
							}

							tmp[`warehouse-${stock.warehouseId}`] = floating.smartStocks.map(smartStock => `${smartStock.stock} ${smartStock.unit}`).join(', ')
							tmp[`warehouse-${stock.warehouseId}-totalSamrtStock`] = stock.smartText
							finalData.push(tmp)
						}

					}

					this.stocksTableData = finalData
					wait.end()

				}).catch(err => { wait.end() })
			},
			showCardex() {
				this.showModal({
					component: defineAsyncComponent(() => import('~/views/reports/product-cardex.vue')),
					options: { product: this.localData },
				})
					.then(() => { })
					.catch(() => { })
			},
			appendPriceLevelsToTable() {
				const columnGenerator = (priceLevel, index) => {
					return {
						name: 'priceLevel' + priceLevel.id,
						title: priceLevel.name,
						type: 'price',
						view: () => {
							return {
								options: {
									type: 'price',
								}
							}
						},
						edit: {
							component: Input,
							options: {
								mode: 'price',
								useDefaultValue: true,
								display: (item) => item
							},
						},
						editable: true,
						width: '100px|>100px',
						validators: validators(new VGreaterThan(-1, true)),
						entering: true,
						align: 'right'
					}
				}
				this.productPriceLevels.forEach((priceLevel, index) => {

					this.componentOptions.prices.columns.splice(index + 2, 0, columnGenerator(priceLevel, index))
				})
			},
			appendWarehousesToOrderPointTable() {
				const columnGenerator = (warehouse, index) => {
					return {
						name: 'warehouse' + warehouse.id,
						title: warehouse.name,
						edit: {
							component: Input,
							options: {
								mode: 'number',
								useDefaultValue: true,
								display: (item) => item
							},
						},
						editable: true,
						width: '100px|>100px',
						validators: validators(new VGreaterThan(-1, true)),
						entering: true,
						align: 'right',
					}
				}
				this.getWarehousesList.forEach((warehouse, index) => {
					this.componentOptions.orderPoints.columns.splice(index + 2, 0, columnGenerator(warehouse, index))
				})
			},
			createWarehouseColumns() {
				const columnGenerator = (warehouse) => {
					return {
						name: `warehouse-${warehouse.id}`,
						title: warehouse.name,
						align: 'center',
						searchable: true,
						sortable: false,
						editable: true,
						width: 'auto',
						aggregates: [
							{
								type: 'sum',
								title: this.$t('table.aggregates.sum'),
								hideTitle: true,
								handler: (data, col) => {

									const SumProperty = `${col.name}-totalSamrtStock`

									data = data.find(x => x[SumProperty])

									if (!data)
										return ''

									return data[SumProperty]
								},
							},
						],
					}
				}

				this.defer(() => {
					let warehouses = this.getWarehousesList

					for (let i = 0; i < warehouses.length; i++)
						this.componentOptions.stock.columns.push(columnGenerator(warehouses[i]))

				}, 1)

			},
			getProductFloatings() {
				const replaceProductFloatingIdByProductFloatingObject = () => {
					let floatingsClone = _.cloneDeep(this.floatings)
					floatingsClone.forEach((floating) => {
						floating.productFloatingValues.forEach((floatingValue) => {
							floatingValue.productFloating = {
								id: floatingValue.productFloatingId
							}
							delete floatingValue.productFloatingId
						})
					})
					this.floatings = floatingsClone
				}
				this.floatings = this.getProductFloatingList
				replaceProductFloatingIdByProductFloatingObject()
				const columnGenerator = (floating) => {
					return {
						name: 'floating' + floating.id,
						title: floating.name,
						edit: () => {
							if (floating.valueType === 'Selective') {
								return {
									component: Dropdown,
									options: {
										searchableFields: ['title'],
										rowIdentifier: 'id',
										display: (item) => item.title,
										getDataFromOptions: true,
										data: floating.productFloatingValues
									}
								}
							} else if (floating.valueType === 'Manual') {
								let inputOptions = {}
								switch (floating.dataType) {
									case "Numeric":
										inputOptions = { mode: 'strnumber' }
										break
									case 'Text':
										inputOptions = { mode: 'text' }
										break
								}
								return {
									component: floating.dataType === 'Date' ? DatePicker : Input,
									options: inputOptions
								}
							}
						},
						view: {
							options: {
								format: (item) => {
									if (floating.valueType === 'Selective')
										return item.title
									else
										return item
								}

							}
						},
						align: 'center',
						searchable: true,
						sortable: false,
						editable: true,
						width: '150px'
					}
				}


				let columns = [{
					name: 'code',
					title: this.$t('code'),
					align: 'center',
					searchable: true,
					sortable: false,
					editable: false,
					width: '100px'
				},
				{
					name: 'barcodes',
					title: this.$t('barcodes'),
					align: 'center',
					searchable: true,
					sortable: false,
					editable: false,
					width: '100px',
					view: {
						options: {
							format: (item) => {
								return item?.join(', ')
							}
						}
					}
				}]
				for (let i = 0; i < this.floatings.length; i++) {
					let col = columnGenerator(this.floatings[i])
					if (i == this.floatings.length - 1)
						col.width = 'auto'
					if (this.floatings[i].valueType == 'Selective') col.search = {
						searchFields: ['title']
					}
					columns.push(col)
				}
				this.componentOptions.floatings.columns.splice(1, 0, ...columns)
			},
			loadProductPriceLevels() {
				post(Endpoints.getUrl('sale.product.price.level.get-list-dynamic'))
					.then(res => {
						this.productPriceLevels = _.sortBy(res.data.items, [(o) => o.displayOrder])
						this.appendPriceLevelsToTable()
					})
			},
			loadRelatableWarehouses() {
				let warehouseTableData = []

				this.localData.assignableWarehouses?.forEach((item) => {
					let obj = {
						id: generateUUID(),
						warehouse: item.warehouse,
						rowState: 'unchanged',
					}

					if (item.warehouse) {
						obj.warehouse = item.warehouse
						warehouseTableData.push(obj)
					} else if (item.warehouse.id) {
						let warehouse = (this.getWarehousesList).find(w => w.id == item.warehouseId)
						if (warehouse) {
							obj.warehouse = wharehouse
							warehouseTableData.push(obj)
						}
					}
				})

				this.relatableWarehouses = warehouseTableData
			},
			async createProductFloatingJsons() {
				const convertTableRowToNormalStructure = (item) => {
					let productFloatingValues = Object.keys(item).filter((key) => key.startsWith('floating') && item[key]).map((key) => {
						if (typeof item[key] === 'object') {
							return item[key]
						} else if (typeof item[key] === 'string') {
							let pfId = key.replace('floating', '')
							return {
								id: emptyId,
								title: item[key],
								productFloating: {
									id: pfId,
								},
								rowState: 'new'
							}
						}
						delete item[key]
					})

					if (isEmpty(item.id))
						item.id = this.generateUUID()

					return {
						productFloatingValues: !isEmpty(productFloatingValues) ? [...productFloatingValues] : [],
						...item
					}
				}
				let floatingsTableData = await this.$refs.floatingTable.commitChanges()
				let data = floatingsTableData.map((floatingsTableRow) => {
					return convertTableRowToNormalStructure(floatingsTableRow)
				})
				return data.filter(x => x.productFloatingValues && x.productFloatingValues.length > 0)
			},
			getProductFloatingsIds(productFloatingJsons) {
				let Ids = []
				if (productFloatingJsons && !_.isEmpty(productFloatingJsons)) {
					productFloatingJsons.productFloatingValues.forEach((floating) => {
						if (floating.id)
							Ids.push(floating.id)
						else
							Ids.push(floating.title)
					})
				}
				return Ids

			},
			allProducts() {
				this.showModal({ component: ProductList })
					.then((result) => {
						this.loadIfPossible(result.code, true, null, true)
						this.defer(() => this.$refs.inputCode.$el.focus(), 1)
					}).catch(err => { })
			},
			async isDataChanged() {
				let localData_cloned = _.cloneDeep(this.localData)
				let originalProduct_cloned = _.cloneDeep(this.originalProduct)
				localData_cloned.code = originalProduct_cloned.code
				let productFloatingJsons = await this.createProductFloatingJsons()
				let prices = await this.convertPriceTableToNormalStructure()
				let orderPoints = await this.convertOrderPointTableToNormalStructure()
				let barcodePrices = this.prepareBarcodePricesForSave()

				delete localData_cloned.productFloatingJsons
				delete localData_cloned.prices
				delete localData_cloned.orderPoints
				delete localData_cloned.barcodePrices
				delete originalProduct_cloned.productFloatingJsons
				delete originalProduct_cloned.prices
				delete originalProduct_cloned.orderPoints
				delete originalProduct_cloned.barcodePrices

				let changed1 = !_.isEqual(originalProduct_cloned, localData_cloned)
				let changed2 = productFloatingJsons.length > 0 ? productFloatingJsons.findIndex(x => x.rowState != 'unchanged') > -1 : false
				let changed3 = prices.length > 0 ? prices.findIndex(x => x.rowState != 'unchanged') > -1 : false
				let changed4 = orderPoints.length > 0 ? orderPoints.findIndex(x => x.rowState != 'unchanged') > -1 : false
				let changed5 = !_.isEqual(this.originalProduct.barcodePrices || [], barcodePrices)

				return changed1 || changed2 || changed3 || changed4 || changed5
			},
			generateUUID() { // Public Domain/MIT
				var d = new Date().getTime()//Timestamp
				var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0//Time in microseconds since page-load or 0 if unsupported
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = Math.random() * 16//random number between 0 and 16
					if (d > 0) {//Use timestamp until depleted
						r = (d + r) % 16 | 0
						d = Math.floor(d / 16)
					} else {//Use microseconds since page-load if supported
						r = (d2 + r) % 16 | 0
						d2 = Math.floor(d2 / 16)
					}
					return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
				})
			},
			fillProduct(product) {
				this.selectDetailRow = null
				this.localData = product
				this.stocksTableData = []
				this.originalProduct = _.cloneDeep(this.localData)
				this.prepareFloatingsTableData(product)
				this.loadRelatableWarehouses()
				this.setFormMode(product)
				this.preparePricesTableData(_.cloneDeep(this.localData.prices || []), _.cloneDeep(this.localData.productFloatingJsons))
				this.prepareOrderPointsTableData(_.cloneDeep(this.localData.orderPoints || []), _.cloneDeep(this.localData.productFloatingJsons))
				this.prepareBarcodePricesTableData(
					_.cloneDeep(this.localData.barcodePrices || product.BarcodePrices || []),
					product.barcodes || [],
					product.productFloatingJsons || []
				)
				this.changeCodeButton.disabled = isEmpty(this.localData.id)
				!isEmpty(product?.id) && (this.componentOptions.stock.buttons.showProductCardex.options.disabled = false)
			},
			prepareFloatingsTableData(product) {
				let productFloatings = []

				product.productFloatingJsons.forEach((floatingRow, rowIndex) => {
					productFloatings.push({})// append empty object for preparing set fields later

					floatingRow.productFloatingValues.forEach((floatingValue) => {
						let pf = this.floatings.find(x => x.id == floatingValue.productFloating.id)
						if (pf) {
							if (pf.valueType === 'Selective') {
								productFloatings[rowIndex]['floating' + pf.id] = floatingValue
								productFloatings[rowIndex]['productf_' + pf.name] = floatingValue?.title || ''
							}
							else if (pf.valueType === 'Manual') {
								productFloatings[rowIndex]['floating' + pf.id] = floatingValue.title
								productFloatings[rowIndex]['productf_' + pf.name] = floatingValue?.title || ''
							}
						}
					})

					productFloatings[rowIndex].uid = floatingRow.id // prevent to set row state as new
					productFloatings[rowIndex].id = floatingRow.id
					productFloatings[rowIndex].code = floatingRow.code
					productFloatings[rowIndex].rowState = floatingRow.rowState
					productFloatings[rowIndex].displayOrder = floatingRow.displayOrder
					productFloatings[rowIndex].barcodes = floatingRow.barcodes
				})
				this.floatingsTableData = productFloatings

				this.selectedFloatingRow = productFloatings[0] || null
			},
			generateKeyFromValues(values) {
				return (values || []).map(x => `${x.id}-${x.productFloating.id}-${x.title}`).sort().join('-')
			},
			async preparePricesTableData(localDataPrices, productFloatingJsons) {
				const findPrice = (priceLevel, productFloatingJson) => {
					let p = localDataPrices.find(x => {
						let k1 = this.generateKeyFromValues((x.productFloatingJson || {}).productFloatingValues)
						let k2 = this.generateKeyFromValues(productFloatingJson.productFloatingValues)
						return ((x.productFloatingJson && x.productFloatingJson.id === productFloatingJson.id) || k1 == k2) && x.productPriceLevel.id == priceLevel.id
					})
					return p ? p.price : ''
				}
				const preparePriceCols = (productFloatingJson) => {
					let obj = {}
					this.productPriceLevels.forEach((priceLevel) => {
						const price = findPrice(priceLevel, productFloatingJson)
						obj['priceLevel' + priceLevel.id] = price
						obj['plevel_' + priceLevel.name] = price
					})
					return obj
				}
				if (!productFloatingJsons)
					productFloatingJsons = await this.createProductFloatingJsons()
				let priceTableData = [{
					id: this.generateUUID(),
					productFloatingJson: { id: emptyId, productFloatingValues: [] },
					...preparePriceCols({ id: emptyId, productFloatingValues: [] })
				}]
				productFloatingJsons.filter(x => x.rowState !== 'deleted').forEach((item) => {
					if (!isEmpty(item.productFloatingValues)) {
						priceTableData.push({
							id: this.generateUUID(),
							productFloatingJson: item,
							...preparePriceCols(item),
						})
					}
				})
				this.priceTableToggler = true
				this.pricesTableData = priceTableData
			},
			async prepareOrderPointsTableData(localDataOrderPoints, productFloatingJsons) {
				const findOrderPoint = (warehouse, productFloatingJson) => {
					let p = localDataOrderPoints.find(x => {
						let k1 = this.generateKeyFromValues((x.productFloatingJson || {}).productFloatingValues)
						let k2 = this.generateKeyFromValues(productFloatingJson.productFloatingValues)
						return ((x.productFloatingJson && x.productFloatingJson.id === productFloatingJson.id) || k1 == k2) && x.warehouse.id == warehouse.id
					})
					return p ? p.count : ''
				}
				const prepareOrderPointCols = (productFloatingJson) => {
					let obj = {}
					this.getWarehousesList.forEach((w) => {
						obj['warehouse' + w.id] = findOrderPoint(w, productFloatingJson)
					})
					return obj
				}
				if (!productFloatingJsons)
					productFloatingJsons = await this.createProductFloatingJsons()
				let orderPointTableData = [{
					id: this.generateUUID(),
					productFloatingJson: { id: emptyId, productFloatingValues: [] },
					...prepareOrderPointCols({ id: emptyId, productFloatingValues: [] })
				}]
				productFloatingJsons.filter(x => x.rowState !== 'deleted').forEach((item) => {
					if (!isEmpty(item.productFloatingValues)) {
						orderPointTableData.push({
							id: this.generateUUID(),
							productFloatingJson: item,
							...prepareOrderPointCols(item),
						})
					}
				})
				this.orderPointToggler = true
				this.orderPointTableData = orderPointTableData
			},
			getProductById(id) {
				return new Promise((resolve, reject) => {
					var url = Endpoints.getUrl('sale.product.get')
					var wait = this.$wait(this.$refs.inputCode.$el, { size: 'small' })
					post(url, { id: id }, null, { silent: true })
						.then((result) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err) => {
							wait.end()
							reject(err)
						})
				})
			},
			getProductByCode(request) {
				return new Promise((resolve, reject) => {
					var url = Endpoints.getUrl('sale.product.get')
					var wait = this.$wait(this.$refs.inputCode.$el, { size: 'small' })
					post(url, { code: request.searchCode }, null, { silent: true })
						.then((result) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err) => {
							wait.end()
							reject(err)
						})
				})
			},
			changedFormAlert(act, params) {
				return new Promise((resolve, reject) => {
					dialog({
						title: this.$t('sale.product.m.unsaved-product.title'),
						body: this.$t('sale.product.m.unsaved-product.body', {
							productCode: this.originalProduct.code,
						}),
						buttons: [
							{
								title: this.$t('document.dialog.saveAsSaved'),
								shortcut: $sc.find('yes', 'dialog'),
								isPrimary: true,
								handle: (button, page, e) => {
									this.localData.code = this.originalProduct.code
									this.trySaveProduct()
										.then((response) => {
											this.$refs.inputCode.$el.focus()
											act(params)
										})
										.then(() => resolve())
										.catch((error) => reject(error))
								},
							},
							{
								title: this.$t('document.dialog.ignoreChanges-load'),
								shortcut: $sc.find('ignore-changes', 'document'),
								isPrimary: true,
								handle: (button, page, e) => {
									act(params)
									resolve()
								},
							},
							{
								title: this.$t('dialog.return'),
								shortcut: $sc.find('return', 'dialog'),
								isCancel: true,
								handle: (button, page, e) => {
									reject()
								},
							},
						],
					})
				})
			},
			async convertPriceTableToNormalStructure() {
				let pricesTableData = this.$refs.priceTable ? await this.$refs.priceTable.commitChanges() : []
				let prices = []

				pricesTableData.forEach((rowData) => {

					if (rowData.productFloatingJson && _.isEmpty(rowData.productFloatingJson.productFloatingValues)) {
						rowData.productFloatingJson = null
					}

					Object.keys(rowData).forEach((key) => {
						if (key.startsWith('priceLevel') && rowData[key]) {
							let priceObject = {
								...rowData,
								productPriceLevel: { id: key.replace('priceLevel', '') },
								price: rowData[key],
							}

							let originalPrice = this.originalProduct.prices.find(x => (x.productFloatingJson || { id: emptyId }).id == (rowData.productFloatingJson || { id: emptyId }).id && x.productPriceLevel.id == priceObject.productPriceLevel.id)
							if (originalPrice) {
								priceObject.id = originalPrice.id
								if (originalPrice.price !== priceObject.price)
									priceObject.rowState = 'changed'
								else
									priceObject.rowState = 'unchanged'
							} else {
								priceObject.id = emptyId
								priceObject.rowState = 'new'
							}

							Object.keys(priceObject).forEach((key) => {
								if (key.startsWith('priceLevel')) {
									delete priceObject[key]
								}
							})

							prices.push(priceObject)
						}
					})
				})

				this.originalProduct.prices.forEach((price) => {
					if (prices.findIndex(x => x.id == price.id) === -1) {
						let deletedPrice = _.cloneDeep(price)
						deletedPrice.rowState = 'deleted'
						prices.push(deletedPrice)
					}
				})

				return prices
			},
			async convertOrderPointTableToNormalStructure() {
				let orderPointsTableData = this.$refs.orderPointTable ? await this.$refs.orderPointTable.commitChanges() : []
				let orderPoints = []

				orderPointsTableData.forEach((rowData) => {

					if (rowData.productFloatingJson && _.isEmpty(rowData.productFloatingJson.productFloatingValues)) {
						rowData.productFloatingJson = null
					}

					Object.keys(rowData).forEach((key) => {
						if (key.startsWith('warehouse') && rowData[key]) {
							let orderPointObject = {
								...rowData,
								warehouse: { id: key.replace('warehouse', '') },
								count: rowData[key],
							}

							let originalOrderPoint = this.originalProduct.orderPoints.find(x => (x.productFloatingJson || { id: emptyId }).id == (rowData.productFloatingJson || { id: emptyId }).id && x.warehouse.id == orderPointObject.warehouse.id)
							if (originalOrderPoint) {
								orderPointObject.id = originalOrderPoint.id
								if (originalOrderPoint.count !== orderPointObject.count)
									orderPointObject.rowState = 'changed'
								else
									orderPointObject.rowState = 'unchanged'
							} else {
								orderPointObject.id = emptyId
								orderPointObject.rowState = 'new'
							}

							Object.keys(orderPointObject).forEach((key) => {
								if (key.startsWith('warehouse') && key != 'warehouse') {
									delete orderPointObject[key]
								}
							})

							orderPoints.push(orderPointObject)
						}
					})
				})

				this.originalProduct.orderPoints.forEach((orderPoint) => {
					if (orderPoints.findIndex(x => x.id == orderPoint.id) === -1) {
						let deletedOrderPoint = _.cloneDeep(orderPoint)
						deletedOrderPoint.rowState = 'deleted'
						orderPoints.push(deletedOrderPoint)
					}
				})

				return orderPoints
			},
			onBlur() {
				if (this.originalProduct != null && !this.onCodeEnterPressed) {
					this.loadIfPossible(this.localData.code)
				}
				this.onCodeEnterPressed = false
			},
			async trySaveProduct() {
				try {
					if (this.$refs.unitTable.clonedData.length === 1) {
						this.$refs.unitTable.clonedData[0].isPrimary = true
					}
					this.localData.barcodes = await this.$refs.barcodeTable.commitChanges()
					this.localData.prices = await this.convertPriceTableToNormalStructure()
					this.localData.orderPoints = await this.convertOrderPointTableToNormalStructure()
					this.localData.units = await this.$refs.unitTable.commitChanges()
					this.localData.formulas = []
					// this.localData.formulas = await this.$refs.formulaTable.commitChanges()
					this.localData.metaDatas = await this.$refs.metaDataList.commitData()
					this.localData.productFloatingJsons = await this.createProductFloatingJsons()
					this.localData.barcodePrices = this.prepareBarcodePricesForSave()

					let assignableWarehouses = []
					let relatableWarehouse = await this.$refs.relatableWarehousesTable.commitChanges()
					relatableWarehouse.forEach((item) => {
						assignableWarehouses.push({
							warehouse: item.warehouse,
							rowState: item.rowState,
						})
					})
					this.localData.assignableWarehouses = assignableWarehouses

					await this.saveProduct()
				} catch (invalidRows) {
					throw invalidRows
				}
			},
			saveProduct() {
				return new Promise((resolve, reject) => {
					let url

					if (isEmpty(this.localData.id)) {
						url = Endpoints.getUrl('sale.product.create')
					} else {
						url = Endpoints.getUrl('sale.product.update')
					}

					let data = {
						product: this.localData,
						imageFileBase64: this.$refs.imageUploader.hasFile() ? this.$refs.imageUploader.getUploadImageDataBase64() : undefined,
					}

					if (this.validateInputs()) {
						let wait = this.$wait(this.grandParent)
						post(url, data)
							.then((response) => {
								wait.end()
								this.$toast(this.$t('sale.product.m.create-success', { name: this.localData.name, code: response.data.productCode }), { type: 'success' })
								data.product.code = response.data.productCode
								this.resolve(data.product)
								this.broadcastItemExist({ form: 'کالا', code: response.data.productCode })
									.then(response => {
										this.clearForm()
										resolve()
									})
									.catch(err => {
										this.clearForm()
										resolve()
									})
							})
							.catch(() => {
								wait.end()
								reject()
							})
					}
				})
			},
			validateInputs() {
				let checker = new Checker((name) => this.$t(`sale.product.f.${name}`))
				let errors = checker.test(this.localData, this.validators.localData)

				// if (!this.localData.isTaxFree)
				// 	if (!this.localData.toll || this.localData.toll === 0)
				// 		if (!this.localData.tax || this.localData.tax === 0)
				// 			errors.push({ key: '', error: this.$t('sale.product.m.tax-or-toll-required') })

				if (this.$refs.unitTable.getTableData().data.length === 0) {
					errors.push({
						key: '',
						error: this.$t(
							'sale.product.m.unit-required-to-save-product'
						),
					})
				}

				this.validationToast(errors)
				return errors.length === 0
			},
			retreiveIsEmpty() {
				return isEmpty(this.localData.id)
			},
			priceHelper() {
				var options = {
					mode: 'select',
				}

				this.showModal({ component: productPriceHelper, options })
					.then((res) => {
						this.localData.prices = this.localData.prices.concat(res)
						this.defer(() => this.$refs.priceTable.$el.focus(), 1)
					})
					.catch(() => {
						this.$refs.priceTable.$el.focus()
					})
			},
			getProperties() {
				this.barcodes = this.getPropertiesByGroup('CodeTypes')
				this.kind = this.getPropertiesByGroup('ProductKindes')
			},
			getDefaultData() {
				return {
					code: '',
					id: emptyId,
					isEnabled: true,
					name: '',
					nameAlternate: '',
					isTaxFree: false,
					metaDatas: null,
					isTollFree: false,
					isSerialized: false,
					barcodes: [],
					productFloatingJsons: [],
					prices: [],
					barcodePrices: [],
					orderPoints: [],
					units: [],
					formulas: null,
					productGroup: null,
					productClassification: null,
					onCodeEnterPressed: false,
					moadianCode: null,
				}
			},
			clearForm() {
				this.setFormMode()
				this.localData = this.getDefaultData()
				this.floatingsTableData = []
				this.stocksTableData = []
				this.relatableWarehouses = []
				this.barcodePricesTableData = []
				this.selectedBarcodePriceRow = null
				this.priceTableToggler = false
				this.orderPointToggler = false
				this.selectedFloatingRow = null
				this.componentOptions.stock.buttons.showProductCardex.options.disabled = true
				this.defer(() => {
					this.originalProduct = _.cloneDeep(this.localData)
					this.activeTab = 'product-unit'
					this.$refs.inputCode.$el.focus()
				}, 100)
			},
			clearBoard() {
				this.isDataChanged().then((isChanged) => {
					if (isChanged) {
						this.changedFormAlert(this.clearForm)
					} else {
						this.clearForm()
					}
				})
			},
			NavigateToProduct(direction, id = this.localData.id) {
				let wait = this.$wait(this.grandParent)

				let data = {
					id: id === emptyId ? null : id,
					navigationDirection: direction,
				}

				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('sale.product.navigate'), data, null, { silent: true })
						.then((result) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err) => {
							wait.end()
							reject(err)
						})
				})
			},
			async onActiveTabChanged(tabId) {
				this.activeTab = tabId

				if (tabId === 'product-barcode') {
					this.$refs.barcodeTable.init(true)
					this.$refs.barcodeTable.table_Focused()
				} else if (tabId === 'product-price') {
					this.preparePricesTableData(await this.convertPriceTableToNormalStructure())
					this.defer(() => {
						this.$refs.priceTable.init(true)
						this.$refs.priceTable.table_Focused()
					}, 100)
				} else if (tabId === 'barcode-prices') {
					this.prepareBarcodePricesTableData(this.barcodePricesTableData)
					this.defer(() => {
						this.$refs.barcodePricesTable?.init(true)
						this.$refs.barcodePricesTable?.table_Focused()
					}, 100)
				} else if (tabId === 'order-point') {
					this.prepareOrderPointsTableData(await this.convertOrderPointTableToNormalStructure())
					this.defer(() => {
						this.$refs.orderPointTable.init(true)
						this.$refs.orderPointTable.table_Focused()
					}, 100)
				} else if (tabId === 'product-unit') {
					this.$refs.unitTable.init(true)
					this.$refs.unitTable.table_Focused()
				} else if (tabId === 'product-costFormula') {
					this.$refs.formulaTable.init(true)
					this.$refs.formulaTable.table_Focused()
				}
			},
			showBarcodesList() {
				if (!this.selectedFloatingRow) {
					this.$toast(this.$t('document.m.select-row'))
					return
				}

				this.showModal({
					component: ProductFloatingBarcodes,
					data: { mainProductId: this.localData.id, barcodes: this.selectedFloatingRow.barcodes || [], productFloating: this.selectedFloatingRow },
				}).then((barcodes) => {
					const activeRowIndex = this.$refs.floatingTable.activeRowIndex

					this.selectedFloatingRow.barcodes = barcodes
					this.$refs.floatingTable.row_tryUpdateRecordAt(activeRowIndex, this.selectedFloatingRow)
				}).catch(() => { })
			},
			getFloatingJsonDisplayName(floatingRow) {
				if (!floatingRow) return '-'
				if (floatingRow.productFloatingValues && floatingRow.productFloatingValues.length > 0) {
					return floatingRow.productFloatingValues.map(v => v.title).filter(Boolean).join(' | ') || '-'
				}
				let titles = Object.keys(floatingRow)
					.filter(k => k.startsWith('productf_') && floatingRow[k])
					.map(k => floatingRow[k])
				if (titles.length > 0) {
					return titles.join(' | ')
				}
				return '-'
			},
			generateBarcodePriceRows(existingPricesList = [], productBarcodes = null, productFloatings = null) {
				const findPrices = (barcode, floatingId) => {
					const existing = (existingPricesList || []).find(x =>
						String(x.barcode) === String(barcode) &&
						((x.productFloatingJsonId == null && floatingId == null) || (String(x.productFloatingJsonId) === String(floatingId)))
					)
					return existing && Array.isArray(existing.prices) ? _.cloneDeep(existing.prices) : []
				}

				let rows = []

				// 1. Own product barcodes
				let ownBarcodes = productBarcodes
				if (ownBarcodes == null) {
					if (this.$refs.barcodeTable && this.activeTab !== 'barcode-prices') {
						ownBarcodes = this.$refs.barcodeTable.getTableData().data || []
					} else {
						ownBarcodes = this.localData.barcodes || []
					}
				}

				ownBarcodes.filter(b => b && b.rowState !== 'deleted' && b.code).forEach(b => {
					const bc = String(b.code)
					rows.push({
						id: this.generateUUID(),
						barcode: bc,
						productFloatingJsonName: '-',
						productFloatingJsonId: null,
						prices: findPrices(bc, null),
					})
				})

				// 2. Floating barcodes
				let floatingsData = productFloatings
				if (floatingsData == null) {
					if (this.floatingsTableData && this.floatingsTableData.length > 0) {
						floatingsData = this.floatingsTableData
					} else {
						floatingsData = this.localData.productFloatingJsons || []
					}
				}

				floatingsData.filter(f => f && f.rowState !== 'deleted').forEach(f => {
					const floatingId = f.id || null
					const floatingName = this.getFloatingJsonDisplayName(f)
					if (f.barcodes && Array.isArray(f.barcodes)) {
						f.barcodes.forEach(bc => {
							if (bc) {
								const bcStr = String(bc)
								rows.push({
									id: this.generateUUID(),
									barcode: bcStr,
									productFloatingJsonName: floatingName,
									productFloatingJsonId: floatingId,
									prices: findPrices(bcStr, floatingId),
								})
							}
						})
					}
				})

				return rows
			},
			prepareBarcodePricesTableData(existingPricesList = null, productBarcodes = null, productFloatings = null) {
				let listToMatch = existingPricesList
				if (listToMatch == null) {
					if (this.$refs.barcodePricesTable) {
						let tableData = this.$refs.barcodePricesTable.getTableData()?.data
						if (tableData && tableData.length > 0) {
							listToMatch = tableData
						}
					}
					if (!listToMatch || listToMatch.length === 0) {
						listToMatch = this.barcodePricesTableData.length > 0
							? this.barcodePricesTableData
							: (this.localData.barcodePrices || [])
					}
				}

				this.barcodePricesTableData = this.generateBarcodePriceRows(listToMatch, productBarcodes, productFloatings)
				this.selectedBarcodePriceRow = this.barcodePricesTableData[0] || null

				if (this.$refs.barcodePricesTable) {
					this.defer(() => {
						this.$refs.barcodePricesTable.init(true)
					}, 50)
				}
			},
			getSelectedBarcodePriceRow() {
				let table = this.$refs.barcodePricesTable
				if (table) {
					let activeIdx = table.activeRowIndex
					let tableData = table.getTableData()?.data || this.barcodePricesTableData
					if (activeIdx >= 0 && activeIdx < tableData.length) {
						return { row: tableData[activeIdx], index: activeIdx }
					}
				}
				if (this.selectedBarcodePriceRow) {
					let tableData = table ? table.getTableData()?.data : this.barcodePricesTableData
					let idx = (tableData || []).findIndex(x => x.id === this.selectedBarcodePriceRow.id || (x.barcode === this.selectedBarcodePriceRow.barcode && x.productFloatingJsonId === this.selectedBarcodePriceRow.productFloatingJsonId))
					return { row: this.selectedBarcodePriceRow, index: idx >= 0 ? idx : 0 }
				}
				if (this.barcodePricesTableData && this.barcodePricesTableData.length > 0) {
					return { row: this.barcodePricesTableData[0], index: 0 }
				}
				return { row: null, index: -1 }
			},
			showBarcodePricesModal() {
				const { row, index } = this.getSelectedBarcodePriceRow()
				if (!row) {
					this.$toast(this.$t('document.m.select-row'))
					return
				}

				this.showModal({
					component: ProductBarcodePrices,
					data: {
						barcode: row.barcode,
						productFloatingJsonName: row.productFloatingJsonName,
						prices: row.prices || [],
					},
				}).then((prices) => {
					const newPrices = prices || []

					// 1. Update row object
					row.prices = newPrices
					this.selectedBarcodePriceRow = row

					// 2. Update in barcodePricesTableData array
					if (this.barcodePricesTableData && this.barcodePricesTableData.length > 0) {
						const dataRow = this.barcodePricesTableData.find(x =>
							x.id === row.id ||
							(String(x.barcode) === String(row.barcode) && ((x.productFloatingJsonId == null && row.productFloatingJsonId == null) || String(x.productFloatingJsonId) === String(row.productFloatingJsonId)))
						)
						if (dataRow) {
							dataRow.prices = newPrices
						} else if (index >= 0 && index < this.barcodePricesTableData.length) {
							this.barcodePricesTableData[index].prices = newPrices
						}
					}

					// 3. Update table UI
					if (index >= 0 && this.$refs.barcodePricesTable) {
						this.$refs.barcodePricesTable.row_tryUpdateRecordAt(index, row)
					}

					// 4. Update localData.barcodePrices
					this.localData.barcodePrices = this.prepareBarcodePricesForSave()
				}).catch(() => { })
			},
			clearBarcodePrices() {
				const { row, index } = this.getSelectedBarcodePriceRow()
				if (!row) {
					this.$toast(this.$t('document.m.select-row'))
					return
				}

				// 1. Update row object
				row.prices = []
				this.selectedBarcodePriceRow = row

				// 2. Update in barcodePricesTableData array
				if (this.barcodePricesTableData && this.barcodePricesTableData.length > 0) {
					const dataRow = this.barcodePricesTableData.find(x =>
						x.id === row.id ||
						(String(x.barcode) === String(row.barcode) && ((x.productFloatingJsonId == null && row.productFloatingJsonId == null) || String(x.productFloatingJsonId) === String(row.productFloatingJsonId)))
					)
					if (dataRow) {
						dataRow.prices = []
					} else if (index >= 0 && index < this.barcodePricesTableData.length) {
						this.barcodePricesTableData[index].prices = []
					}
				}

				// 3. Update table UI
				if (index >= 0 && this.$refs.barcodePricesTable) {
					this.$refs.barcodePricesTable.row_tryUpdateRecordAt(index, row)
				}

				// 4. Update localData.barcodePrices
				this.localData.barcodePrices = this.prepareBarcodePricesForSave()
			},
			prepareBarcodePricesForSave() {
				let currentTableData = this.$refs.barcodePricesTable ? this.$refs.barcodePricesTable.getTableData().data : this.barcodePricesTableData
				let rows = (currentTableData && currentTableData.length > 0)
					? currentTableData
					: this.generateBarcodePriceRows(this.localData.barcodePrices || [])

				return rows.map(r => ({
					productFloatingJsonId: r.productFloatingJsonId || null,
					barcode: String(r.barcode || ''),
					prices: (r.prices || []).map(p => Number(p)).filter(p => !isNaN(p)),
				}))
			},
			print_dataSources() {
				const data = _.cloneDeep(this.localData)

				data.floatings = this.floatingsTableData
				data.floatingsByBarcode = []

				for (let item of this.floatingsTableData) {
					if (item.barcodes?.length > 0) {
						const prices = this.pricesTableData.find(x => x.productFloatingJson?.id === item.id)
						for (let barcode of item.barcodes) {

							data.floatingsByBarcode.push({ ...item, barcode: barcode, ...prices })
						}
					}
				}


				const productDataSource = {
					name: 'Product',
					data: data,
					translatedDataSetName: this.$t(`EntityTypes.Product`),
					translatePrefix: 'sale.product.f',
					converter: {
						type: PrintDataConvertTypes.MAPPER,
						settings: {
							code: 'code',
							name: 'name',
							productGroup: (item) => item?.name || '',
							kind: (item) => item ? this.$t(`ProductKindes.${item.toLowerCase()}`) : '',
							technicalNumber: 'technicalNumber',
							defaultWarehouse: (item) => item?.name || '',
							marketingPercentage: 'marketingPercentage',
							moadianCode: 'moadianCode',
							tax: (item) => item || 0,
							toll: (item) => item || 0,
							units: {
								unitName: 'name',
								unitRate: 'rate',
								isPrimary: 'isPrimary',
								weight: 'weight',
								weightUnit: (item) => item ? this.$t(`enum-items.WeightUnits.${item}`) : '',
								volume: 'volume',
								volumeUnit: (item) => item ? this.$t(`enum-items.VolumeUnits.${item}`) : '',
								width: 'width',
								widthUnit: (item) => item ? this.$t(`enum-items.DimensionUnits.${item}`) : '',
								height: 'height',
								heightUnit: (item) => item ? this.$t(`enum-items.DimensionUnits.${item}`) : '',
								length: 'length',
								lengthUnit: (item) => item ? this.$t(`enum-items.DimensionUnits.${item}`) : '',
							},
							barcodes: {
								barcode: 'code',
								barcodeType: (item, row) => row.type ? this.$t(`sale.product.barcode-type.${row.type}`) : ''
							},
							floatings: {
								floatingCode: 'code',
								barcodes: (item, row) => item && Array.isArray(item) ? item.join(', ') : '',
								floatingsCombination: (item, row) => row ? Object.keys(row).filter(x => x.includes('productf_')).map(x => row[x]).join(', ') : ''
							},
							floatingsByBarcode: {
								floatingCode: 'code',
								barcode: 'barcode',
								floatingsCombination: (item, row) => row ? Object.keys(row).filter(x => x.includes('productf_')).map(x => row[x]).join(', ') : ''
							}
						}
					}
				}

				for (let i = 0; i < this.floatings.length; i++) {
					const floating = this.floatings[i]
					productDataSource.converter.settings.floatings[`_${floating.name}`] = (item, row) => row[`productf_${floating.name}`]
					productDataSource.converter.settings.floatingsByBarcode[`_${floating.name}`] = (item, row) => row[`productf_${floating.name}`]
				}


				for (let j = 0; j < this.productPriceLevels.length; j++) {
					const priceLevel = this.productPriceLevels[j]
					productDataSource.converter.settings.floatingsByBarcode[`_${this.$t('price')} ${priceLevel.name}`] = (item, row) => row[`plevel_${priceLevel.name}`] ? String(Number(row[`plevel_${priceLevel.name}`]).toFixed()) : '0'
				}

				return [productDataSource]
			},
			showGenerateBarcodes() {
				if (this.retreiveIsEmpty()) {
					this.$toast(this.$t('core.generate-pattern.m.product-must-be-already-saved'), { type: 'error' })
					return
				}
				this.showModal({
					component: GenerateBarcodesByPattern,
					options: {
						entitytType: 'ProductBarcode'
					},
					data: {
						entityId: this.localData.id
					}
				})
					.then((res) => {
						if (!res)
							return
						this.localData.barcodes.push(...res.map(code => {
							return {
								id: emptyId,
								code: code,
								codeType: "Barcode",
								productId: this.localData.id,
								rowState: "new"
							}
						}))
					})
					.catch((err) => {
						console.log(err)
					})
			},
			showGenerateFloatingBarcodes() {
				if (this.retreiveIsEmpty()) {
					this.$toast(this.$t('core.generate-pattern.m.product-must-be-already-saved'), { type: 'error' })
					return
				}
				let data = this.$refs.floatingTable.getTableData().data
				if (data.some(x => x.uid === emptyId)) {
					this.$toast(this.$t('core.generate-pattern.m.all-floatings-must-be-already-saved'), { type: 'error' })
					return
				}
				this.showModal({
					component: GenerateBarcodesByPattern,
					options: {
						entitytType: 'ProductFloatingBarcode'
					},
					data: {
						entityId: this.localData.id,
						productFloatings: this.floatingsTableData
					}
				})
					.then((res) => {
						for (var item of res) {
							let rowIndex = data.findIndex(x => x.id === item.productFloatingJsonId)
							if (rowIndex === -1)
								continue
							let row = data[rowIndex]
							row.barcodes = row.barcodes || []
							row.barcodes.push(...item.barcodes)
							row.rowState = row.rowState === 'new' ? row.rowState : 'changed'
							this.$refs.floatingTable.row_tryUpdateRecordAt(rowIndex, row)
						}
					})
					.catch((err) => {
						console.log(err)
					})
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'load-product',
					keyCode: 13,
					el: this.$refs.inputCode.$el,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						this.onCodeEnterPressed = true
						this.loadIfPossible(this.localData.code)
					},
				}),
					this.$keyHandler.Subscribe({
						name: 'all-products',
						keyCode: 32,
						el: this.$refs.inputCode.$el,
						context: this,
						ctrlKey: true,
						handler: function (sender, e) {
							this.allProducts()
						},
					})
			}
		},
	}
</script>
<style lang="less">
	.product-table {
		height: 325px !important;
	}

	.order-point-hint {
		background-color: #ffeeee;
		padding: 7px;
		border-radius: 5px;
		color: #ec4242;
	}

	.no-floating {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 10;
		background-color: transparent;
		backdrop-filter: blur(10px);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		span {
			font-size: 20px;
			font-weight: 600;
		}

		a {
			display: block;
			font-size: 16px;
			cursor: pointer;
		}
	}

	.visual-card {
		width: 270px !important;
	}

	.information-card {
		flex: 1;
	}

	.switch-position {
		top: -3px;
	}

	@media screen and (max-width: 767px) {
		.visual-card {
			width: auto !important;
		}

		.mobile {
			flex-direction: column-reverse !important;
		}

		.nk-page .nk-seprator::after {
			display: none;
		}

		.image-container {
			margin-right: auto;
			margin-left: auto;
		}
	}
</style>
